module.exports = __webpack_public_path__ + "static/ltrsktrs-f84d36a48047919abd0267725f8a08f5.gif";